import * as React from 'react';
import { IReview } from '../../components/Reviews';
import { trackAllReviewsClick, trackReviewItemClick, trackReviewsScroll } from './tracking';

export const useTracking = (visible: boolean) => {
  React.useEffect(() => {
    if (visible) {
      trackReviewsScroll();
    }
  }, [visible]);

  const handleReviewItemClick = React.useCallback((review: IReview) => {
    trackReviewItemClick(review);
  }, []);

  const handleAllReviewsClick = React.useCallback(() => {
    trackAllReviewsClick();
  }, []);

  return {
    handleReviewItemClick,
    handleAllReviewsClick,
  };
};
